module.exports = __webpack_public_path__ + "img/button-e-claim-form_TC.6deaf1c3.png";